module.exports = __webpack_public_path__ + "static/media/gdBee2.e2f915d8.jpg";